import { Ref, useContext, useImperativeHandle, useMemo } from 'react'
import { getStatesArr } from '../../lib/Utils'
import { ICompanyFilters, ICompanyQuery } from '../../types/Company'
import ClearButton from '../ui/ClearButton'
import SingleLineMultiSelect from '../ui/SingleLineMultiSelect'
import SuccessButton from '../ui/SuccessButton'
import FilterContainer from './FilterContainer'

import { useForm } from 'react-hook-form'
import Grid from '@mui/material/Grid'
import GlobalContext from '../../contexts/GlobalContext'
import CompanyFilterInput from '../ui/CompanyFilterInput'
import React from 'react'

interface Props {
  onSearch: (values: ICompanyQuery) => void
  onClear: () => void
}
export interface CompaniesFilterRefType {
  getValues: () => any
}

const CompanyFilters = (
  { onSearch, onClear }: Props,
  ref: Ref<CompaniesFilterRefType>
) => {
  const { control, reset, getValues } = useForm<ICompanyFilters>({})
  const { setMobileFilterActive } = useContext(GlobalContext)

  const ALL_STATES = useMemo(() => getStatesArr(), [])

  const getQuery = () => {
    const { client, state, ...values } = getValues()

    const filterFields = []

    if (values.trailer?.length) {
      filterFields.push({
        value: values.trailer,
        type: 'SELECT',
        searchKey: 'trailer_types'
      })
    }

    if (values.position?.length) {
      filterFields.push({
        value: values.position,
        type: 'SELECT',
        searchKey: 'position_available'
      })
    }

    const query = {
      _id: client?._id,
      filterFields: filterFields,
      stateCodes: state
    }

    return query
  }
  const onSubmit = () => {
    onSearch(getQuery())
    setMobileFilterActive()
  }

  useImperativeHandle(ref, () => ({ getValues: getQuery }))

  return (
    <FilterContainer>
      <form
        className="w-full"
        onSubmit={(e) => {
          e.preventDefault()
          e.stopPropagation()
          //   reset({})
        }}>
        <Grid
          spacing={0.5}
          container
          sx={{
            px: { lg: 0, xs: 1 }
          }}
          direction="row"
          justifyContent="start"
          alignItems="stretch">
          <Grid size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
            <SingleLineMultiSelect
              control={control}
              controlName="state"
              placeholder="State Of Operation"
              fieldNames={{
                fieldLabel: 'label',
                fieldValue: 'value'
              }}
              staticData={ALL_STATES}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
            <SingleLineMultiSelect
              control={control}
              controlName="trailer"
              vocabularyKey="trailer_types"
              placeholder="Trailer Types"
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
            <SingleLineMultiSelect
              control={control}
              controlName="position"
              vocabularyKey="position_available"
              placeholder="Position Available"
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 2 }}>
            <CompanyFilterInput control={control}></CompanyFilterInput>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 'grow' }}>
            <ClearButton
              className="mr-1 h-full"
              onClick={() => {
                reset()
                onClear()
                setMobileFilterActive()
              }}>
              Clear
            </ClearButton>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2, lg: 2, xl: 'grow' }}>
            <SuccessButton onClick={onSubmit}>SEARCH</SuccessButton>
          </Grid>
        </Grid>
      </form>
    </FilterContainer>
  )
}

export default React.forwardRef(CompanyFilters)
